<template>
  <div class="labeled-text-area-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <TextAriaInput
      ref="textAriaInput"
      class="text-area-input"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :limit="limit"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import InputLabel from '../label';
import TextAriaInput from '../text-area-input';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      inputId: `input-text-${this.generateRandomId()}`,
    };
  },
  computed: {
    getTextAreaInput() {
      return this.$refs.textAriaInput;
    }
  },
  components: { InputLabel, TextAriaInput },
  methods: {
    generateRandomId,
  },
};
</script>

<style lang="scss" scoped>
.labeled-text-area-input {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.text-area-input {
  flex-grow: 1;
}
</style>
